import {contentVisualPreviewImageElement} from '@cohort/components-xps/components/contents/apps/utils';
import type {MediaSize} from '@cohort/shared/utils/media';
import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import {ArticleNyTimes} from '@phosphor-icons/react';

type CohortArticleVisualPreviewContentProps = {
  imageFileKey: string | null;
  title: string;
  isMobile: boolean;
  imageSize: MediaSize;
  className?: string;
};

const CohortArticleVisualPreviewContent: React.FC<CohortArticleVisualPreviewContentProps> = ({
  imageFileKey,
  title,
  isMobile,
  imageSize,
  className,
}) => {
  if (!imageFileKey) {
    return (
      <div className={cn('flex h-full', isMobile ? 'justify-center' : 'items-center justify-end')}>
        <ArticleNyTimes
          size={isMobile ? 225 : 180}
          className={cn('text-inherit opacity-30')}
          viewBox={isMobile ? '0 0 256 230' : '40 25 140 210'}
        />
      </div>
    );
  }

  const imageSrc = getImageUrl(import.meta.env.COHORT_ENV, imageFileKey, {
    h: Sizes[imageSize],
    w: Sizes[imageSize],
  });

  return contentVisualPreviewImageElement(title, imageSrc, className);
};

export default CohortArticleVisualPreviewContent;
